let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cuA5s")).then(() => parcelRequire('1n1IO'));